import React from "react";
import { TopBar, Logo } from "./styles";
import Menu from "../../components/NavHeader";
import logo from "../../assets/tkg_move.png";

// import { Container } from './styles';

function Main({ children, title, color }) {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "row",
        background: "whitesmoke",
        position: 'absolute',
        top: 0,
        bottom: 0,
        left: 0,
        right: 0
      }}
    >
      <Menu />
      <div style={{ width: "100%", marginLeft: "50px", background: color }}>
        <TopBar style={{ zIndex: 99999 }}>
          <Logo src={logo} />
          {title ? (
            <p
              style={{
                margin: 0,
                borderLeft: "0.5px solid #7d7d7dfc",
                paddingLeft: 20,
                marginLeft: 20,
                fontWeight: "initial",
                color: "#1b1919",
              }}
            >
              {title}
            </p>
          ) : null}
        </TopBar>
        <div style={{ margin: 20, paddingTop: 60, background: color }}>
          {children}
        </div>
      </div>
    </div>
  );
}

export default Main;
